

































































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import CancelledReason from '@/models/Shared/CancelledReason';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import CancelShiftViewModel from '@/models/Shifts/CancelShiftViewModel';
import CancelBookingRoleWorkerShiftViewModel from '@/models/BookingRoleWorkerShifts/CancelBookingRoleWorkerShiftViewModel';

@Component({
    name: 'BookingRoleWorkerShiftCancel'
})
export default class BookingRoleWorkerShiftCancel extends GiganautVueDialog {
 
  cancelledReason: CancelledReason = CancelledReason.CANCELLED_REASON_WORKER_NO_LONGER_AVAILABLE;
  cancelledText = '';
  @Prop({required: true})
	bookingRoleWorkerShiftId: string;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.cancelledText = '';
      this.cancelledReason = CancelledReason.CANCELLED_REASON_WORKER_NO_LONGER_AVAILABLE;
    }
  }

  get cancelledReasons() {
    return ListUtils.cancelledReasonsForWorker();
  }

  get cancellationDisabled () {
    return this.cancelledText !== 'CANCEL'
  }


  async confirm() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const vm = new CancelBookingRoleWorkerShiftViewModel()
    //vm.updatedAt = BookingDetailsModule.currentBooking.updatedAt;
    vm.cancelledReason = this.cancelledReason;
    vm.bookingRoleWorkerShiftId = this.bookingRoleWorkerShiftId;
    
    await BookingDetailsModule.cancelBookingRoleWorkerShift(vm)
    await BookingDetailsModule.updateOfferedSelectedBookingRole(BookingDetailsModule.selectedBookingRole);
    await BookingDetailsModule.updateBookedSelectedBookingRole(BookingDetailsModule.selectedBookingRole);
    this.dialog = false;
  }
}
